import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_seo_parent_product_cell = _resolveComponent("seo-parent-product-cell");
  const _component_b_td = _resolveComponent("b-td");
  const _component_b_tr = _resolveComponent("b-tr");
  return _openBlock(), _createBlock(_component_b_tr, {
    class: "parent-seo-row seo-row",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('handleToggle'))
  }, {
    default: _withCtx(() => [_createVNode(_component_seo_parent_product_cell, {
      parent: $props.parent,
      collapsed: $props.collapsed
    }, null, 8, ["parent", "collapsed"]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(13, i => {
      return _createVNode(_component_b_td, {
        key: i,
        class: _normalizeClass(["col", {
          'seo-parent-td': !$props.collapsed
        }])
      }, null, 8, ["class"]);
    }), 64)), _createVNode(_component_b_td, {
      class: _normalizeClass(["b-table-sticky-column table-b-table-default custom-td border-table-row stick-to-right col", {
        'seo-parent-td': !$props.collapsed
      }]),
      style: {
        right: '147px'
      }
    }, null, 8, ["class"]), _createVNode(_component_b_td, {
      class: _normalizeClass(["b-table-sticky-column table-b-table-default custom-td border-table-row stick-to-right col", {
        'seo-parent-td': !$props.collapsed
      }]),
      style: {
        right: '115px'
      }
    }, null, 8, ["class"]), _createVNode(_component_b_td, {
      class: _normalizeClass(["b-table-sticky-column table-b-table-default custom-td border-table-row stick-to-right col", {
        'seo-parent-td': !$props.collapsed
      }]),
      style: {
        right: '36px'
      }
    }, null, 8, ["class"]), _createVNode(_component_b_td, {
      class: _normalizeClass(["b-table-sticky-column table-b-table-default custom-td border-table-row stick-to-right col last-parent-td", {
        'seo-parent-td': !$props.collapsed
      }]),
      style: {
        right: '0'
      }
    }, null, 8, ["class"])]),
    _: 1
  });
}